import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import packageInfo from '../package.json';

console.log(
  `%c Alfin Contacto v${packageInfo.version} `,
  'background: #1a237e; color: #fff; font-size: 14px; padding: 4px 8px; border-radius: 4px;'
);

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();